import { useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'

import MultiSelectBox from '../../../../../../../../features/components/Form/MultiSelectBox'

import { getLoadOptionsHandlerCursorPagination } from '../../../../../../../../features/helpers/componentsHelpers'

import { getGoogleAdManagerConstantsService } from '../../../../../../../../modules/services/rights'

import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'
import { GAM_NETWORK_CODE } from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { gamConstantsTypes, GEO_TARGETING } from '../../../fields'

const GeographySelect = ({ formik }) => {
  const { values, setFieldValue } = formik

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const formatOptions = useCallback(options => {
    return options
      .filter(option => option?.geo_target_type === 'COUNTRY')
      .map(option => ({
        ...option,
        value: option.id,
        label: option.name
      }))
  }, [])

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandlerCursorPagination({
      getOptionsService: getGoogleAdManagerConstantsService,
      params: {
        network_code: gamNetworkCode,
        constant_type: gamConstantsTypes.Geo_Target
      },
      formatOptions: formatOptions,
      limit: 1000,
      allowFetchNext: false
    })
  }, [formatOptions, gamNetworkCode])

  return (
    <MultiSelectBox
      loadOptions={loadOptions}
      value={values[GEO_TARGETING]}
      name={GEO_TARGETING}
      setFieldValue={setFieldValue}
      placeholder="Geography"
      portaled={true}
    />
  )
}

export default GeographySelect
